if (typeof Piramide !== " function") {
  window.Piramide = function (wrapper, duracion, formato, data) {
    let box = new Box({
      size: { width: 1600, height: 1200 },
      padding: { left: 20, top: 20, right: 20, bottom: 50 },
    });

    let svg = null;
    let gEjeX = null;
    let gEjeY = null;
    let gMain = null;
    let gLeyenda = null;

    let svgLeyenda = null;
    let gEtiquetas = null;

    const xM = d3
      .scaleLinear()
      .domain([0, d3.max(data, (d) => d.total)])
      .rangeRound([
        box.content.width / 2 - (formato == "horizontal" ? 50 : 80),
        0,
      ]);

    const xF = d3
      .scaleLinear()
      .domain(xM.domain())
      .rangeRound([
        box.content.width / 2 + (formato == "horizontal" ? 50 : 80),
        box.content.width,
      ]);

    const y = d3
      .scaleBand()
      .domain(data.map((d) => d.grupo))
      .rangeRound([box.content.height, 0])
      .padding(0.1);

    const color = d3
      .scaleOrdinal()
      .domain(["HOMBRES", "MUJERES"])
      .range(["#5bcfb8", "#a54cfc"]);

    const colorVacunacion = d3
      .scaleOrdinal()
      .domain(["HOMBRES", "MUJERES"])
      .range(["#419181", "#6c36a3"]);

    function setup() {
      crearSVG(wrapper);
      crearPiramide();
    }

    function crearSVG(wrapper) {
      svg = wrapper
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height}`);

      svg = svg.append("g");

      svg = svg
        .append("g")
        .attr(
          "transform",
          `translate(${box.padding.left}, ${box.padding.top})`
        );

      gEjeX = svg
        .append("g")
        .style("stroke-width", 0.5)
        .style("fill", "transparent")
        .attr("data-g", "gEjeX")
        .attr("transform", `translate(0, ${box.content.height})`);

      let gM = gEjeX.append("g").call(d3.axisBottom(xM));
      let gF = gEjeX.append("g").call(d3.axisBottom(xF));

      gEjeY = svg
        .append("g")
        .style("stroke-width", 0.5)
        .style("fill", "transparent")
        .attr("data-g", "gEjeY")
        .attr(
          "transform",
          `translate(${xM(0) + (formato == "horizontal" ? 60 : 90)}, 0)`
        )
        .call(d3.axisLeft(y).tickSizeOuter(0));

      gEjeY.attr("text-anchor", "middle");

      gMain = svg
        .append("g")
        .style("stroke-width", 0.5)
        .style("fill", "transparent")
        .attr("data-g", "gMain");

      gLeyenda = svg.append("g").attr("data-g", "gLeyenda");

      let arreglo = ["Sin vacuna", "Con vacuna"];
      let l = 40;
      let espacio = 20;
      let valY = 0;

      let gLeyendaHombres = gLeyenda
        .append("g")
        .attr("transform", "translate(0,50)");

      gLeyendaHombres
        .append("text")
        .text("Hombres")
        .attr("x", 0)
        .attr("y", valY);

      valY += espacio;

      _.each(arreglo, function (d, i) {
        let colorRelleno =
          i == 0 ? color("HOMBRES") : colorVacunacion("HOMBRES");
        let texto = i == 0 ? "Sin vacuna" : "Con vacuna";

        gLeyendaHombres
          .append("rect")
          .style("fill", colorRelleno)
          .attr("x", 0)
          .attr("y", valY)
          .attr("width", l)
          .attr("height", l);

        gLeyendaHombres
          .append("text")
          .text(texto)
          .attr("x", l + espacio / 2)
          .attr("y", valY + l / 2 + 3)
          .attr("dominant-baseline", "middle");

        valY += espacio + l;
      });

      valY = 0;
      let gLeyendaMujeres = gLeyenda.append("g");

      gLeyendaMujeres
        .append("text")
        .text("Mujeres")
        .attr("x", 0)
        .attr("y", valY);

      valY += espacio;

      _.each(arreglo, function (d, i) {
        let colorRelleno =
          i == 0 ? color("MUJERES") : colorVacunacion("MUJERES");
        let texto = i == 0 ? "Sin vacuna" : "Con vacuna";

        gLeyendaMujeres
          .append("rect")
          .style("fill", colorRelleno)
          .attr("x", 0)
          .attr("y", valY)
          .attr("width", l)
          .attr("height", l);

        gLeyendaMujeres
          .append("text")
          .text(texto)
          .attr("x", l + espacio / 2)
          .attr("y", valY + l / 2 + 3)
          .attr("dominant-baseline", "middle");

        valY += espacio + l;
      });

      let cajaMujeres = gLeyendaMujeres.node().getBBox();
      gLeyendaMujeres.attr(
        "transform",
        `translate(${box.content.width - cajaMujeres.width},50)`
      );
    }

    function crearPiramide() {
      gMain
        .append("g")
        .selectAll("rect")
        .data(_.cloneDeep(data))
        .join("rect")
        .each(function (d) {
          d.key = "no_vacunadas";
        })
        .attr("fill", (d) => color(d.sexo))
        .attr("x", (d) => (d.sexo === "HOMBRES" ? xM(d.total) : xF(0)))
        .attr("y", (d) => y(d.grupo))
        .attr("width", (d) =>
          d.sexo === "HOMBRES" ? xM(0) - xM(d.total) : xF(d.total) - xF(0)
        )
        .attr("height", y.bandwidth())
        .on("mouseover", crearTooltip)
        .on("mouseout", deshacerTooltip);

      gMain
        .append("g")
        .selectAll("rect")
        .data(_.cloneDeep(data))
        .join("rect")
        .each(function (d) {
          d.key = "vacunadas";
        })
        .attr("fill", (d) => colorVacunacion(d.sexo))
        .attr("x", (d) => (d.sexo === "HOMBRES" ? xM(d.vacunadas) : xF(0)))
        .attr("y", (d) => y(d.grupo))
        .attr("width", (d) =>
          d.sexo === "HOMBRES"
            ? xM(0) - xM(d.vacunadas)
            : xF(d.vacunadas) - xF(0)
        )
        .attr("height", y.bandwidth())
        .on("mouseover", crearTooltip)
        .on("mouseout", deshacerTooltip);

      gMain
        .append("g")
        .attr("fill", "white")
        .selectAll("text")
        .data(data)
        .join("text")
        .attr("text-anchor", (d) => (d.sexo === "HOMBRES" ? "start" : "end"))
        .attr("x", (d) =>
          d.sexo === "HOMBRES" ? xM(d.total) + 10 : xF(d.total) - 10
        )
        .attr("y", (d) => y(d.grupo) + y.bandwidth() / 2)
        .attr("dy", "0.35em")
        .text((d) => getTextoTotal(d));
    }

    function getTextoTotal(d) {
      if (formato == "horizontal") {
        return d.total > 40 ? d.total : "";
      }
      return d.total > 80 ? d.total : "";
    }

    function crearTooltip(e, d) {
      let etiqueta = d.key == "vacunadas" ? "con vacuna" : "sin vacuna";

      let [x, y] = d3.pointer(e, this);
      let el = d3.select(this);
      y = +el.attr("y");

      let gTooltip = gMain.append("g").attr("class", "tooltip ignore");

      let rect = gTooltip
        .append("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", 0)
        .attr("height", 0)
        .style("fill", "#ffffff")
        .style("stroke", "gray")
        .style("stroke-width", "2px");

      let text = gTooltip
        .append("text")
        .attr("x", 0)
        .attr("y", 0)
        .attr("dy", 0)
        .attr("text-anchor", "middle");

      text.append("tspan").style("font-weight", 700).text(`${d[d.key]}`);
      text.append("tspan").text(` ${d.sexo.toLowerCase()} ${etiqueta}`);

      let caja = text.node().getBBox();

      y -= caja.height - 10;
      y = y <= 0 ? 20 : y;

      rect
        .attr("x", caja.x - 10)
        .attr("y", caja.y - 10)
        .attr("width", caja.width + 20)
        .attr("height", caja.height + 20);

      let overflow = x + (caja.x - 10) + (caja.width + 20);
      let underflow = x - (caja.x - 10 + (caja.width + 20));
      let width = caja.width + 20;

      if (overflow > box.content.width) {
        gTooltip.attr(
          "transform",
          `translate(${box.content.width - width / 2}, ${y})`
        );
      } else if (underflow < 0) {
        gTooltip.attr("transform", `translate(${0 + width / 2}, ${y})`);
      } else {
        gTooltip.attr("transform", `translate(${x}, ${y})`);
      }
    }

    function deshacerTooltip(e, d) {
      gMain.selectAll("g.tooltip").remove();
    }

    setup();
  };
}
